(function () {
  'use strict';

  const gsap = window.gsap;
  const CustomEase = window.CustomEase;
  gsap.registerPlugin(CustomEase);

  const { iman, layout, debounce, loadAnimation, InitWhenVisible } = window.Universe;

  const DEBOUNCE_TIMEOUT = 150;

  function initCore() {
    document.documentElement.classList.add('js');
    layout.init();

    if (Universe.Cart) iman.add('cart', new Universe.Cart());
    if (Universe.Navigation) iman.add('navigation', new Universe.Navigation());
    if (Universe.AnnouncementBar) iman.add('announcementBar', new Universe.AnnouncementBar());
    if (Universe.Marquees) iman.add('marquees', new Universe.Marquees());
    if (Universe.Accordions) iman.add('accordions', new Universe.Accordions());
    if (Universe.ScrollAnimator) iman.add('scrollAnimator', new Universe.ScrollAnimator());
    if (Universe.ProductForms && !iman.get('productForms')) iman.add('productForms', new Universe.ProductForms());
    if (Universe.HighlightText && !iman.get('highlightText')) iman.add('highlightText', new Universe.HighlightText());

    // Components that are never needed until the user interacts: defer their
    // constructor cost off the critical path. In design mode keep them immediate
    // so the editor's section reload events reach them right away.
    const initDeferred = () => {
      if (Universe.LocalizationManager && !iman.get('localizationManager'))
        iman.add('localizationManager', new Universe.LocalizationManager());
      if (Universe.Footer && !iman.get('footer')) iman.add('footer', new Universe.Footer());
      if (Universe.ScrollTo && !iman.get('scrollTo')) iman.add('scrollTo', new Universe.ScrollTo());
    };

    if (Shopify.designMode) {
      initDeferred();
      document.body.removeAttribute('data-page-rendering');
    } else {
      new InitWhenVisible(() => {
        initDeferred();
        document.body.removeAttribute('data-page-rendering');
      });
    }
  }

  function onResize() {
    layout.resize();
    iman.map('resize');
  }

  // Swap the browser-tab title for a custom message once the visitor leaves the
  // tab. The message appears 5s after switching away, and the timer is cleared
  // (and the original title restored) the moment they come back.
  function initFaviconTabMessage() {
    const tabMessage = window.theme && window.theme.faviconTabMessage;
    if (!tabMessage) return;

    const DELAY = 5000;
    let timer = null;
    let originalTitle;

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        originalTitle = document.title;
        timer = window.setTimeout(() => {
          document.title = tabMessage;
        }, DELAY);
      } else {
        window.clearTimeout(timer);
        timer = null;
        if (originalTitle !== undefined) document.title = originalTitle;
      }
    });
  }

  // Low priority: defer to idle time so it never competes with the critical path.
  const lowPriority = window.requestIdleCallback || ((cb) => window.setTimeout(cb, 1));
  lowPriority(initFaviconTabMessage);

  if (Shopify.designMode) {
    initCore();

    // Quando una sezione viene aggiunta o ri-renderizzata dall'editor
    document.addEventListener('shopify:section:load', (event) => {
      const sectionEl = event.target;

      // Reset scroll animations: rimuovi is-visible dagli elementi nella sezione
      // così che le animazioni possano ripartire
      const animatedEls = sectionEl.querySelectorAll('.is-visible');
      animatedEls.forEach((el) => {
        el.classList.remove('is-visible');
      });

      // Reinit scoped: ogni componente gestisce solo la propria sezione
      iman.map('reinitSection', sectionEl);
    });

    // Quando una sezione viene rimossa dall'editor
    document.addEventListener('shopify:section:unload', (event) => {
      const sectionEl = event.target;
      iman.map('destroySection', sectionEl);
    });

    // Quando un blocco viene selezionato (es. una slide specifica)
    document.addEventListener('shopify:block:select', (event) => {
      iman.map('onBlockSelect', event.target);
    });

    // Quando un blocco viene deselezionato
    document.addEventListener('shopify:block:deselect', (event) => {
      iman.map('onBlockDeselect', event.target);
    });
  } else {
    document.addEventListener('DOMContentLoaded', initCore);
    window.addEventListener('DOMContentLoaded', () => {
      loadAnimation();
    });
  }

  window.addEventListener('resize', debounce(onResize, DEBOUNCE_TIMEOUT));
  window.addEventListener('orientationchange', debounce(onResize, DEBOUNCE_TIMEOUT));

  window.iman = iman;
})();
